import styled from 'styled-components';
import { useRef, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY, SHOW_COMMEMORATE } from 'src/constants';
import { convertObjPath, convertObjPathNoneEncode } from 'src/utils/helper';
import { useForm } from 'react-hook-form';
import { CgClose } from 'react-icons/cg';
import { ErrorMessage } from '@hookform/error-message';

const WidgetSearchFullPage = ({ toggle, handle, searchInPage = false, searchText = '' }) => {
  const recaptchaRef = useRef(null);
  // console.log('recaptchaRef,', recaptchaRef);
  const searchBoxRef = useRef();

  // ---------- expand Search ----------
  const [recaptchaBox, setRecaptchaBox] = useState(false);
  const [toggleValue, setToggleValue] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    watch
  } = useForm();
  const textSearch = watch('textSearch');
  const recaptchaSearch = textSearch || searchText;

  const onSearch = e => {
    setRecaptchaBox(true);
  };

  const onReCAPTCHAChange = async captchaCode => {
    if (!captchaCode) return null;

    try {
      const response = await fetch('/api/search/recaptcha', {
        method: 'POST',
        body: JSON.stringify({ textSearch: recaptchaSearch, captcha: captchaCode }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setRecaptchaBox(false);
        const serachParams = convertObjPathNoneEncode({
          q: encodeURIComponent(recaptchaSearch || '')
        });

        window.location.href = await `/search${serachParams}`;
      } else {
        const error = await response.json();
        throw new Error(error.message);
      }
    } catch (err) {
      alert(err?.message || 'Something went wrong');
      setRecaptchaBox(false);
    } finally {
      recaptchaRef.current = null;
      setRecaptchaBox(false);
    }
  };
  return (
    <>
      {!searchInPage ? (
        <>
          <SearchBox className='absolute'>
            <div
              className={`slide-search ${toggle ? 'fadein' : 'fadeout'}`}
              style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}
            >
              <button id='close-search' onClick={() => handle()} aria-label='Search Close'>
                <CgClose />
              </button>
              {recaptchaBox && (
                <BoxRecaptcha>
                  <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
                </BoxRecaptcha>
              )}
              <form onSubmit={handleSubmit(onSearch)} className='search-box-full' ref={searchBoxRef}>
                <input type='text' {...register('textSearch')} required placeholder='ค้นหา ...' className='text-search' />
                <ButtonSearch type='submit' aria-label='Search Submit'>
                  <FaSearch />
                </ButtonSearch>
              </form>
            </div>
          </SearchBox>
        </>
      ) : (
        <>
          {recaptchaBox && (
            <BoxRecaptcha position='fixed' positionTop recaptchaDesktop>
              <ReCAPTCHA ref={recaptchaRef} sitekey={RECAPTCHA_SITE_KEY} onChange={onReCAPTCHAChange} />
            </BoxRecaptcha>
          )}
          <SearchBoxDesktopInpageSearch>
            <form onSubmit={handleSubmit(onSearch)} className='btn-search' ref={searchBoxRef}>
              {!textSearch && <>{!toggleValue && <h1 className='text-item'>{searchText}</h1>}</>}
              <input
                {...register('textSearch')}
                className='search-in-page text-search'
                type='text'
                placeholder={toggleValue ? 'ค้นหา ...' : ''}
                onClick={() => setToggleValue(true)}
                onMouseLeave={() => setToggleValue(false)}
              />
              <button type='submit' aria-label='Search Submit'>
                <FaSearch />
              </button>
            </form>
            <p className='error-search-in-page'>
              <ErrorMessage errors={errors} name='textSearch' />
            </p>
          </SearchBoxDesktopInpageSearch>
        </>
      )}
    </>
  );
};

const SearchBoxDesktopInpageSearch = styled.div`
  form {
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #00000071;
    &.btn-search {
      .text-item {
        text-transform: uppercase;
        font-size: 32px;
        font-weight: 500;
        color: #000000;
        transition: border-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9), width 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9);
        position: absolute;
        top: 0;
        z-index: -1;
      }
    }
    .text-search {
      transition: all 0.5s;
      background-color: transparent;
      vertical-align: middle;
      position: relative;
      outline: 0;
      /* height: 36px; */
      line-height: 50px;
      margin: 0;
      padding: 0 0;
      font-size: 32px;
      font-weight: 500;
      color: #000000;
      border: none;
      box-sizing: border-box;
      transition: border-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9), width 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9);
    }
    button {
      cursor: pointer;
      border: unset;
      background-color: unset;
      padding: 0;
    }
    svg {
      vertical-align: middle;
      color: rgb(0, 0, 0);
      font-size: 20px;
    }
  }
  .search-in-page {
    width: 100%;
  }
  .error-search-in-page {
    margin-top: 5px;
    color: red;
    font-size: 12px;
  }
`;

const BoxRecaptcha = styled.div`
  position: ${props => (props.position ? props.position : 'relative')};
  top: ${props => (props.positionTop ? '0' : 'auto')};
  width: ${props => props.recaptchaDesktop && '100%'};
  height: ${props => (props.recaptchaDesktop ? '100vh' : '100%')};
  background-color: rgb(0, 0, 0, 0.5) !important;
  z-index: 99;
  right: 0;
  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const ButtonSearch = styled.button`
  display: flex;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  vertical-align: middle;
  border-bottom: 2px solid ${({ color }) => color || '#000'};
  border-radius: 0px;
  svg {
    color: ${({ theme: { color } }) => color?.theme};
  }

  @media (max-width: 768px) {
    width: ${props => (props.height ? props.height : '100%')};
  }

  &:focus {
    outline: none;
  }
`;

const SearchBox = styled.div`
  display: contents;
  .slide-search {
    overflow: hidden;
    position: fixed;
    padding: 0px;
    background-color: var(--primary-color);
    z-index: 999;
    top: 0px;
    width: 100%;
    height: 100vh;
    right: -101%;
    transition: ease-in-out 400ms;

    button {
      border: none;
      font-size: 30px;
      position: absolute;
      top: 0;
      right: 0%;
      width: 80px;
      height: 80px;
      z-index: 25;
      background: none;
      color: #000;

      &:focus {
        outline: 0;
      }
    }

    &.fadein {
      right: 0;
    }

    &.fadeout {
    }

    .search-box-full {
      width: 100%;
      max-width: 600px;
      margin: auto 0;
      position: absolute;
      top: 35%;
      left: 48%;
      transform: translate(-50%, 50%);

      input {
        caret-color: red;
        display: block;
        text-align: start;
        width: 100%;
        margin: 5px auto;
        padding: 10px 0 10px 15px;
        /* background-color: transparent !important; */
        background: none;
        border: none;
        color: #000;
        border-bottom: 1px solid #000;
        box-shadow: #000 0px 10px 7px -10px;

        font-size: 32px !important;
        font-weight: 400;
        border-radius: 0px;

        &:focus {
          outline: none;
        }

        &::placeholder {
          color: #000;
          background-color: transparent !important;
        }
      }

      button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        margin-top: 0px;
        right: 0;
        top: 15px;
        font-size: 24px;
        border: none;
        /* width: 100%; */
        height: 55px;
        color: #000;
        background: none;

        &:focus {
          outline: none;
        }

        &:hover {
          svg {
            filter: drop-shadow(1px 2px 2px #000);
          }
          background: transparent !important;
        }
      }
    }

    @media (max-width: 768px) {
      .search-box-full {
        width: 80%;
        left: 50%;
      }
    }

    @media (max-width: 480px) {
      .search-box-full {
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        input {
          width: 100%;
        }
      }
    }
  }
`;

export default WidgetSearchFullPage;
